var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"header pa-2"},[_c('img',{attrs:{"src":require("@/assets/img/logo_fqm_branco.svg"),"alt":"Logo"}}),_c('h1',[_vm._v(_vm._s(_vm.$route.meta.titulo.text))])]),_c('v-container',{staticClass:"pa-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }